// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../config/axios";
// import Logo from "../../assets/images/loginimage.png";
// import IndDayImage from "../../assets/images/independence-day-login.jpg";
// import NewYear2025Gif from "../../assets/gif/newyear.gif";
// import Diwali2025Gif from "../../assets/gif/Diwali2025.gif";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import usePermission from "../../config/permissions";
// import { ToastContainer, toast } from "react-toastify";
// import { handleErrorToast } from "../../components/CustomFunctions";
// import { PasswordEye, PasswordEyeHidden } from "../../components/AllSvg";
// import { setEncryptionKey, clearEncryptionKey, getCurrentEncryptionKey } from '../../utils/secureStorage';
// import { getActiveHoliday } from "../../config/holidayConfig";
// import "./LoginIndDay.css";

// const MailIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="5" width="18" height="14" rx="2" ry="2" />
//     <polyline points="3 7 12 13 21 7" />
//   </svg>
// );

// const LockIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
//     <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//   </svg>
// );

// const Login = () => {

//   const navigate = useNavigate();
//   const { updatePermissions } = usePermission(); // Use the hook

//   const [errMsg, setErrMsg] = useState("");

//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const [showPassword, setShowPassword] = useState(false);

//   // Check for active holiday theme
//   const activeHoliday = getActiveHoliday();
//   const isIndependenceDay = activeHoliday?.theme === "independence-day";

//   useEffect(() => {
//     // Check if the fields have been auto-filled by the browser
//     const emailInput = document.getElementById('email');
//     const passwordInput = document.getElementById('password');
//     if (emailInput && passwordInput) {
//       setFormData({
//         email: emailInput.value,
//         password: passwordInput.value
//       });
//       setInputState({
//         email: emailInput.value ? 'green' : '',
//         password: passwordInput.value ? 'green' : '',
//       });
//     }
//   }, []);

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
//       newErrors.email = 'Invalid email format';
//     }

//     const requiredFields = [
//       'password',
//     ];

//     requiredFields.forEach(field => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
//       }
//     });

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const [loading, setLoading] = useState(false); //loading logic

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setLoading(true); //loading logic
//       // const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//       // toast.success(`Logging In...`);
//       const loadingToastId = toast.loading(`Logging In...`); //toast Logic

//       try {
//         let res = await axios.post(`${BASE_URL}/user/login/`, formData);

//         if (res.status === 200) {
//           toast.success(`Logging In...`);

//           const { access, refresh, payload, employeecode, payload_a, letter } = res.data;

//           clearEncryptionKey();

//           setEncryptionKey(access);

//           const sessionData = {
//             access_token: access,
//             refresh_token: refresh,
//             role: payload.role,
//             email: payload.email,
//             emp_code: employeecode,
//             department: payload_a.department,
//             department_name: payload_a.department_name,
//             rh: payload_a.reporting_head,
//             is_rh: payload_a.is_reporthead,
//             profilepic: payload_a.profilepic,
//             // letter_type: letter,
//             name: payload_a.name,
//             company: payload_a.division_name,
//             company_id: payload_a.sub_company_id,
//           };

//           // Set items in sessionStorage - encryption happens automatically
//           Object.entries(sessionData).forEach(([key, value]) => {
//             sessionStorage.setItem(key, value);
//           });

//           updatePermissions();

//           try {
//             const fetchPopup = await axios.get(
//               `${BASE_URL}/wfm/popupbysub_company/${payload_a.sub_company_id}/`
//             );

//             if (fetchPopup.status === 200) {
//               const popups = fetchPopup.data;
//               const today = new Date();
//               localStorage.setItem("companyPopups", JSON.stringify(popups));
//               console.log('today-', today)
//               popups.forEach((popup) => {
//                 const start = new Date(popup.start_visibility);
//                 const end = new Date(popup.end_visibility);
//                 console.log('start-', start)
//                 console.log('end-', end)

//                 if (today >= start && today <= end) {
//                   localStorage.setItem(`popup-${popup.id}`, "true");
//                 } else {
//                   localStorage.setItem(`popup-${popup.id}`, "false");
//                 }
//               });
//             }
//             else {
//               console.error("Error fetching popups");
//             }
//           } catch (err) {
//             console.error("Error fetching popups:", err);
//           }

//           navigate("/");
//           window.location.reload();
//         } else {
//           setErrMsg("Invalid Email Or Password");
//         }
//       } catch (err) {
//         console.log(err);
//         setErrMsg(err.response.data.error);
//         handleErrorToast(err, loadingToastId);
//         // setErrMsg("Invalid Email Or Password");
//       } finally {
//         setLoading(false); //loading logic
//         toast.dismiss(loadingToastId);
//       }
//     } else {
//       console.log('Form contains errors:', errors);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? 'green' : '',
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     setErrMsg("");
//   };

//   const forgotpass = () => {
//     navigate("/forgotpassword");
//   }


//   const handleKeyPress = (event) => {
//     // Check if the pressed key is Enter (key code 13)
//     if (event.key === 'Enter') {
//       event.preventDefault(); // Prevent the default form submission
//       handleSubmit(event);
//     }
//   };

//   // ==========================================
//   // Independence Day Themed Login
//   // ==========================================
//   if (isIndependenceDay) {
//     return (
//       <>
//         <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         <div className="login-page-ind-day">

//           {/* HRMS Logo - Top Right */}
//           <div className="login-ind-hrms-logo">
//             <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <circle cx="24" cy="14" r="7" fill="#138808" />
//               <circle cx="14" cy="28" r="7" fill="#FF9933" />
//               <circle cx="34" cy="28" r="7" fill="#1d3674" />
//               <path d="M24 21C20 21 17 24 14 28" stroke="#FF9933" strokeWidth="2" fill="none" opacity="0.4" />
//               <path d="M24 21C28 21 31 24 34 28" stroke="#1d3674" strokeWidth="2" fill="none" opacity="0.4" />
//             </svg>
//             <span>HRMS</span>
//           </div>

//           {/* Left Panel - Independence Day Illustration */}
//           <div className="login-ind-left">
//             <img src={IndDayImage} alt="Happy Independence Day - 15th August" />
//           </div>

//           {/* Right Panel - Login Card */}
//           <div className="login-ind-right-card">
//             <div className="login-ind-first-heading">Hello!</div>
//             <div className="login-ind-second-heading">Welcome Back 👋</div>
//             <div className="login-ind-third-heading">The world is just a step away from here.</div>

//             {/* Tricolor Separator */}
//             <div className="tricolor-line">
//               <div className="line-orange"></div>
//               <div className="line-blue-circle"></div>
//               <div className="line-green"></div>
//             </div>

//             <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form login-ind-form">
//               <div className="flex-column">
//                 <label htmlFor="email" className="form-labels">Email:</label>
//                 <div className="input-wrapper">
//                   <div className="input-icon-left">
//                     <MailIcon />
//                   </div>
//                   <input
//                     type="text"
//                     id="email"
//                     name="email"
//                     placeholder="example@gmail.com"
//                     autoComplete="off"
//                     onChange={handleInputChange}
//                     value={formData.email}
//                     onInput={(e) => {
//                       e.target.value = e.target.value.toLowerCase().trim();
//                     }}
//                     className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
//                   />
//                 </div>
//                 {errors.email && (
//                   <span className="error-message font-size-text ">{errors.email}</span>
//                 )}</div>
//               <div className="flex-column">
//                 <label htmlFor="password" className="form-labels">Password:</label>
//                 <div className="input-wrapper">
//                   <div className="input-icon-left">
//                     <LockIcon />
//                   </div>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     placeholder="*********"
//                     id="password"
//                     name="password"
//                     onChange={handleInputChange}
//                     value={formData.password}
//                     className={`form-input ${errors.password ? 'error' : inputState.password ? 'success' : ''}`}
//                   />
//                   {errors.password && (
//                     <span className="error-message font-size-text ">{errors.password}</span>
//                   )}
//                   <button
//                     type="button"
//                     style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', display: 'flex' }}
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? (
//                       <PasswordEye />
//                     ) : (
//                       <PasswordEyeHidden />
//                     )}
//                   </button>
//                 </div>
//               </div>
//               <div>
//                 <button type="submit" className="login-button font-weight600 font-size-heading" disabled={loading}>
//                   Sign In
//                 </button>
//               </div>
//               <button className="forgotbutton font-weight600 font-size-text" onClick={forgotpass}>Forgot Password?</button>
//               <br></br>
//               <p
//                 style={{ color: "red" }}
//                 className={errMsg ? "errmsg" : "offscreen"}
//                 aria-live="assertive"
//               >
//                 {errMsg}
//               </p>
//             </form>
//           </div>

//           {/* Footer Quote */}
//           <div className="login-ind-footer">
//             <div className="login-ind-footer-quote">
//               <span className="quote-mark">"</span>
//               {" "}Freedom is not just a word, it's a <span className="highlight">responsibility</span>.{" "}
//               <span className="quote-mark">"</span>
//             </div>
//             <div className="login-ind-footer-line">
//               <div className="line-orange"></div>
//               <span className="heart">♡</span>
//               <div className="line-green"></div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }

//   // ==========================================
//   // Default / Normal Login (existing UI)
//   // ==========================================
//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       <div className='login-page'>

//         {/* Diwali GIF */}
//         {/* <div style={{width:'50%'}}>
//           <Link to="/">
//             <img style={{width:'100%'}} src={Diwali2025Gif} alt='logo' className='login-page-img' />
//           </Link>
//         </div> */}

//         <div>
//           <Link to="/">
//             <img src={Logo} alt="logo" className="login-page-img" />
//           </Link>
//         </div>
//         <div className='login-page-right width-35vw'>
//           <div className='login-page-first-heading font-weight300'>Hello!</div>
//           <div className='login-page-second-heading font-weight600'>Welcome Back👋</div>
//           <div className='login-page-third-heading font-weight300 font-size-heading'>The world is just a step away from here </div>
//           <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form">
//             <div className="flex-column">
//               <label htmlFor="email" className='form-labels'>Email:</label>
//               <input
//                 type="text"
//                 id="email"
//                 name="email"
//                 placeholder="example@gmail.com"
//                 autoComplete="off"
//                 onChange={handleInputChange}
//                 value={formData.email}
//                 onInput={(e) => {
//                   e.target.value = e.target.value.toLowerCase().trim();// Convert input to lowercase
//                 }}
//                 className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
//                 style={{width:'stretch'}}
//               />
//               {errors.email && (
//                 <span className="error-message font-size-text ">{errors.email}</span>
//               )}</div>
//             <div className="flex-column">

//               <label htmlFor="password" className='form-labels'>Password:</label>
//               <div style={{ position: 'relative' }}>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   placeholder="*********"
//                   id="password"
//                   name="password"
//                   onChange={handleInputChange}
//                   value={formData.password}

//                   className={`form-input ${errors.password ? 'error' : inputState.password ? 'success' : ''}`}
//                   style={{width:'stretch'}}
//                 />
//                 {errors.password && (
//                   <span className="error-message font-size-text ">{errors.password}</span>
//                 )}
//                 <button
//                   type="button"
//                   style={{ position: 'absolute', right: 20, top: 20 }}
//                   onClick={() => setShowPassword(!showPassword)}
//                 >
//                   {showPassword ? (
//                     <PasswordEye />
//                   ) : (
//                     <PasswordEyeHidden />
//                   )}
//                 </button>
//               </div>
//             </div>
//             <div>
//               <button type="submit" className="login-button font-weight600  font-size-heading" disabled={loading}>
//                 Sign In
//               </button>
//             </div>
//             <button className="forgotbutton  font-weight600  font-size-text " onClick={forgotpass}>Forgot Password ?</button>
//             <br></br>
//             <p
//               style={{ color: "red" }}
//               className={errMsg ? "errmsg" : "offscreen"}
//               aria-live="assertive"
//             >
//               {errMsg}
//             </p>

//           </form>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Login


import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import Logo from "../../assets/images/loginimage.png";
import NewYear2025Gif from "../../assets/gif/newyear.gif";
import Diwali2025Gif from "../../assets/gif/Diwali2025.gif";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast } from "../../components/CustomFunctions";
import {
  PasswordEye, PasswordEyeHidden,
  // WavedIndianFlag 
} from "../../components/AllSvg";
import { setEncryptionKey, clearEncryptionKey, getCurrentEncryptionKey } from '../../utils/secureStorage';
// import { getActiveHoliday } from "../../config/holidayConfig";
// import "./LoginIndDay.css";
// import IndependenceDay from "../../assets/images/independence_day_.png";

// const MailIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="5" width="18" height="14" rx="2" ry="2" />
//     <polyline points="3 7 12 13 21 7" />
//   </svg>
// );

// const LockIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
//     <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//   </svg>
// );

// Small reusable firework burst
// const Firework = ({ color = "#FF9933", size = 60 }) => (
//   <svg className="ind-firework" width={size} height={size} viewBox="0 0 60 60" fill="none">
//     {[...Array(10)].map((_, i) => {
//       const angle = (i * 36 * Math.PI) / 180;
//       const x1 = 30 + Math.cos(angle) * 6;
//       const y1 = 30 + Math.sin(angle) * 6;
//       const x2 = 30 + Math.cos(angle) * (i % 2 === 0 ? 26 : 16);
//       const y2 = 30 + Math.sin(angle) * (i % 2 === 0 ? 26 : 16);
//       return (
//         <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.8" />
//       );
//     })}
//     <circle cx="30" cy="30" r="3" fill={color} opacity="0.9" />
//   </svg>
// );

// Small flying bird
// const Bird = () => (
//   <svg className="ind-bird" width="22" height="12" viewBox="0 0 22 12" fill="none">
//     <path d="M1 8C4 2 8 2 11 6C14 2 18 2 21 8" stroke="#3a4a63" strokeWidth="1.6" strokeLinecap="round" fill="none" opacity="0.55" />
//   </svg>
// );

const Login = () => {

  const navigate = useNavigate();
  const { updatePermissions } = usePermission(); // Use the hook

  const [errMsg, setErrMsg] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const [showPassword, setShowPassword] = useState(false);

  // Check for active holiday theme
  // const activeHoliday = getActiveHoliday();
  // const isIndependenceDay = activeHoliday?.theme === "independence-day";

  useEffect(() => {
    // Check if the fields have been auto-filled by the browser
    const emailInput = document.getElementById('email');
    const passwordInput = document.getElementById('password');
    if (emailInput && passwordInput) {
      setFormData({
        email: emailInput.value,
        password: passwordInput.value
      });
      setInputState({
        email: emailInput.value ? 'green' : '',
        password: passwordInput.value ? 'green' : '',
      });
    }
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    const requiredFields = [
      'password',
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading(`Logging In...`); //toast Logic

      try {
        let res = await axios.post(`${BASE_URL}/user/login/`, formData);

        if (res.status === 200) {
          toast.success(`Logging In...`);

          const { access, refresh, payload, employeecode, payload_a, letter } = res.data;

          clearEncryptionKey();

          setEncryptionKey(access);

          const sessionData = {
            access_token: access,
            refresh_token: refresh,
            role: payload.role,
            email: payload.email,
            emp_code: employeecode,
            department: payload_a.department,
            department_name: payload_a.department_name,
            rh: payload_a.reporting_head,
            is_rh: payload_a.is_reporthead,
            profilepic: payload_a.profilepic,
            name: payload_a.name,
            company: payload_a.division_name,
            company_id: payload_a.sub_company_id,
          };

          // Set items in sessionStorage - encryption happens automatically
          Object.entries(sessionData).forEach(([key, value]) => {
            sessionStorage.setItem(key, value);
          });

          updatePermissions();

          try {
            const fetchPopup = await axios.get(
              `${BASE_URL}/wfm/popupbysub_company/${payload_a.sub_company_id}/`
            );

            if (fetchPopup.status === 200) {
              const popups = fetchPopup.data;
              const today = new Date();
              localStorage.setItem("companyPopups", JSON.stringify(popups));
              popups.forEach((popup) => {
                const start = new Date(popup.start_visibility);
                const end = new Date(popup.end_visibility);

                if (today >= start && today <= end) {
                  localStorage.setItem(`popup-${popup.id}`, "true");
                } else {
                  localStorage.setItem(`popup-${popup.id}`, "false");
                }
              });
            }
            else {
              console.error("Error fetching popups");
            }
          } catch (err) {
            console.error("Error fetching popups:", err);
          }

          navigate("/");
          window.location.reload();
        } else {
          setErrMsg("Invalid Email Or Password");
        }
      } catch (err) {
        console.log(err);
        setErrMsg(err.response.data.error);
        handleErrorToast(err, loadingToastId);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    } else {
      console.log('Form contains errors:', errors);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrMsg("");
  };

  const forgotpass = () => {
    navigate("/forgotpassword");
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  // ==========================================
  // Independence Day Themed Login
  // ==========================================
  // if (isIndependenceDay) {
  //   return (
  //     <>
  //       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
  //       <div className="login-page-ind-day">

  //         <div className="ind-blob ind-blob-bottomright"></div>



  //         {/* Fireworks */}
  //         <div className="ind-fw ind-fw-1"><Firework color="#FFB066" size={90} /></div>
  //         <div className="ind-fw ind-fw-2"><Firework color="#FFB066" size={55} /></div>
  //         <div className="ind-fw ind-fw-3"><Firework color="#138808" size={65} /></div>
  //         <div className="ind-fw ind-fw-4"><Firework color="#138808" size={30} /></div>

  //         {/* Left Text + Illustration */}
  //         <div className="login-ind-left">


  //           <img src={IndependenceDay} alt="Independence Day"
  //             //  width={400} height={487} 
  //             className="independence-day-image"
  //           />




  //         </div>



  //         <div className="login-ind-right-card">
  //           <div className="login-ind-first-heading">Hello!</div>
  //           <div className="login-ind-second-heading">Welcome Back
  //             <WavedIndianFlag width={60} height={30} />
  //           </div>
  //           <div className="login-ind-third-heading">The world is just a step away from here</div>

  //           <div className="tricolor-line">
  //             <div className="line-orange"></div>
  //             <div className="line-blue-circle"></div>
  //             <div className="line-green"></div>
  //           </div>

  //           <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form">
  //             <div className="flex-column">
  //               <label htmlFor="email" className='form-labels'>Email:</label>
  //               <input
  //                 type="text"
  //                 id="email"
  //                 name="email"
  //                 placeholder="example@gmail.com"
  //                 autoComplete="off"
  //                 onChange={handleInputChange}
  //                 value={formData.email}
  //                 onInput={(e) => {
  //                   e.target.value = e.target.value.toLowerCase().trim();// Convert input to lowercase
  //                 }}
  //                 className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
  //                 style={{ width: 'stretch' }}
  //               />
  //               {errors.email && (
  //                 <span className="error-message font-size-text ">{errors.email}</span>
  //               )}</div>
  //             <div className="flex-column">

  //               <label htmlFor="password" className='form-labels'>Password:</label>
  //               <div style={{ position: 'relative' }}>
  //                 <input
  //                   type={showPassword ? "text" : "password"}
  //                   placeholder="*********"
  //                   id="password"
  //                   name="password"
  //                   onChange={handleInputChange}
  //                   value={formData.password}

  //                   className={`form-input ${errors.password ? 'error' : inputState.password ? 'success' : ''}`}
  //                   style={{ width: 'stretch' }}
  //                 />
  //                 {errors.password && (
  //                   <span className="error-message font-size-text ">{errors.password}</span>
  //                 )}
  //                 <button
  //                   type="button"
  //                   style={{ position: 'absolute', right: 20, top: 20 }}
  //                   onClick={() => setShowPassword(!showPassword)}
  //                 >
  //                   {showPassword ? (
  //                     <PasswordEye />
  //                   ) : (
  //                     <PasswordEyeHidden />
  //                   )}
  //                 </button>
  //               </div>
  //             </div>
  //             <div>
  //               <button type="submit" className="login-button font-weight600  font-size-heading" disabled={loading}>
  //                 Sign In
  //               </button>
  //             </div>
  //             <button className="forgotbutton  font-weight600  font-size-text " onClick={forgotpass}>Forgot Password ?</button>
  //             <br></br>
  //             <p
  //               style={{ color: "red" }}
  //               className={errMsg ? "errmsg" : "offscreen"}
  //               aria-live="assertive"
  //             >
  //               {errMsg}
  //             </p>

  //           </form>
  //         </div>

  //         {/* Footer Quote */}
  //         <div className="login-ind-footer">
  //           <div className="login-ind-footer-quote">
  //             <span className="quote-mark">"</span>
  //             {" "}Freedom is not just a word, it's a <span className="highlight">responsibility</span>.{" "}
  //             <span className="quote-mark">"</span>
  //           </div>
  //           <div className="login-ind-footer-line" style={{ marginTop: '-2px' }}>
  //             <div className="line-orange"></div>
  //             <span className="heart">♡</span>
  //             <div className="line-green"></div>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // }

  // ==========================================
  // Default / Normal Login (existing UI)
  // ==========================================
  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className='login-page'>
        <div>
          <Link to="/">
            <img src={Logo} alt="logo" className="login-page-img" />
          </Link>
        </div>
        <div className='login-page-right width-35vw'>
          <div className='login-page-first-heading font-weight300'>Hello!</div>
          <div className='login-page-second-heading font-weight600'>Welcome Back👋</div>
          <div className='login-page-third-heading font-weight300 font-size-heading'>The world is just a step away from here </div>
          <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form">
            <div className="flex-column">
              <label htmlFor="email" className='form-labels'>Email:</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="example@gmail.com"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.email}
                onInput={(e) => {
                  e.target.value = e.target.value.toLowerCase().trim();
                }}
                className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
                style={{ width: 'stretch' }}
              />
              {errors.email && (
                <span className="error-message font-size-text ">{errors.email}</span>
              )}</div>
            <div className="flex-column">

              <label htmlFor="password" className='form-labels'>Password:</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="*********"
                  id="password"
                  name="password"
                  onChange={handleInputChange}
                  value={formData.password}
                  className={`form-input ${errors.password ? 'error' : inputState.password ? 'success' : ''}`}
                  style={{ width: 'stretch' }}
                />
                {errors.password && (
                  <span className="error-message font-size-text ">{errors.password}</span>
                )}
                <button
                  type="button"
                  style={{ position: 'absolute', right: 20, top: 20 }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <PasswordEye />
                  ) : (
                    <PasswordEyeHidden />
                  )}
                </button>
              </div>
            </div>
            <div>
              <button type="submit" className="login-button font-weight600  font-size-heading" disabled={loading}>
                Sign In
              </button>
            </div>
            <button className="forgotbutton  font-weight600  font-size-text " onClick={forgotpass}>Forgot Password ?</button>
            <br></br>
            <p
              style={{ color: "red" }}
              className={errMsg ? "errmsg" : "offscreen"}
              aria-live="assertive"
            >
              {errMsg}
            </p>

          </form>
        </div>
      </div>
    </>
  )
}

export default Login
